import { gaugeProgressPercentage } from "@/lib/tableGaugeMath";
import { MetricBar } from "@/components/ui/table";

export type MetricGaugeCellProps = {
  displayText: string;
  value: number;
  maxValue: number;
};

export const MetricGaugeCell = ({ displayText, value, maxValue }: Readonly<MetricGaugeCellProps>) => (
  <MetricBar value={value} pct={gaugeProgressPercentage(value, maxValue)} displayText={displayText} />
);
